<ng-container *ngComponentOutlet="anfrageLiveSharingComponent"></ng-container>
<div class="h-100 d-flex overflow-y-hidden overflow-x-hidden">
        <prozess-navigation
            id="resizableLeft"
            *ngIf="this.portalkonfiguration.mittelabrufAbschnitt && navItem"
            class="navigation"
            [ngClass]="{ 'collapsed': !showProzessNavigation }"
            >
            <div>
                <app-navigation-item
                    [name]="navItem.name"
                    [href]="'./' + navItem.link"
                    [isValid]="true"
                    [isActive]="true"
                    [showValidationStatus]="false"
                    [formIcon]="navItem.icon"
                    (click)="onAppNavigationItemClick()"
                    >
                </app-navigation-item>
            </div>
            <div (mousedown)="draggableSidebar.onMouseDown($event, 'resizableLeft')" class="resize-bar right" [ngClass]="{'hidden' : ! showProzessNavigation}"></div>
        </prozess-navigation>
    <main class="content" id="main-content">
        <div id="topPosition"></div>
        <router-outlet></router-outlet>
    </main>

    <ng-component *ngComponentOutlet="detailSidepaneComponent"></ng-component>

</div>
